import { ChannelType } from "./ChannelType";
import { DeviceClass, DeviceClasses } from "./DeviceClasses";
import Point from "./Point";
import { itx } from "../translationItx/itx";

export enum DrawingItemCategory {
  Button,
  Consumer,
  Memo,
  Room,
}

export default class DrawingItemTemplate {
  className = "DrawingItemTemplate"; // no itx

  classification: DeviceClass = DeviceClasses.Unknown;

  category: DrawingItemCategory = DrawingItemCategory.Consumer;

  type = ChannelType.Switch;
  center = new Point(0, 0);
  image = state.hostBaseUrl + "images/consumer/lamp.png"; // no itx
  titleShort = itx("drawingItemTemplate.titledimmShort", "dim");
  name = "";
  tag = "";

  toJSON() {
    return this;
  }
}
